var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.87322 3.5C8.87322 3.15384 9.15384 2.87322 9.5 2.87322C9.84616 2.87322 10.1268 3.15384 10.1268 3.5L8.87322 3.5ZM9.9432 14.9432C9.69843 15.188 9.30157 15.188 9.0568 14.9432L5.06797 10.9544C4.8232 10.7096 4.8232 10.3127 5.06797 10.068C5.31275 9.8232 5.7096 9.8232 5.95438 10.068L9.5 13.6136L13.0456 10.068C13.2904 9.8232 13.6873 9.8232 13.932 10.068C14.1768 10.3127 14.1768 10.7096 13.932 10.9544L9.9432 14.9432ZM9.5 3.5L10.1268 3.5L10.1268 14.5L9.5 14.5L8.87322 14.5L8.87322 3.5L9.5 3.5Z",
    fill: "#00C05B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownGreen);
export default __webpack_public_path__ + "static/media/down_green.b0d60f389465e6f786fb461d66073803.svg";
export { ForwardRef as ReactComponent };